import { ADD_COMBO_SERVICE_TO_CART, UPDATE_COMBO_SERVICE_CART } from '~/store/actions/CartComboServiceAction/type';

const initState = {
    cartComboServiceInfo: JSON.parse(localStorage.getItem('cartComboService')) || [],
};

const CartComboServiceReducer = (state = initState, action) => {
    switch (action.type) {
        case ADD_COMBO_SERVICE_TO_CART: {
            let newState = { ...state };
            const newItem = { ...action.payload };
            const index = state.cartComboServiceInfo.findIndex((x) => x.id === action.payload.id);
            newItem.key = newItem.id;

            if (index >= 0) {
                newState.cartComboServiceInfo[index].amount_order += newItem.amount_order;

                newState.cartComboServiceInfo[index].total_price =
                    newState.cartComboServiceInfo[index].amount_order *
                    newState.cartComboServiceInfo[index].deducted_price;
            } else {
                // San pham chua co trong gio hang
                newState.cartComboServiceInfo.unshift(newItem);
            }

            localStorage.setItem('cartComboService', JSON.stringify(newState.cartComboServiceInfo));
            return newState;
        }

        case UPDATE_COMBO_SERVICE_CART: {
            let newState = { ...state };
            const newCart = action.payload;
            newState.cartComboServiceInfo = newCart;
            localStorage.setItem('cartComboService', JSON.stringify(newState.cartComboServiceInfo));
            return newState;
        }

        default:
            return state;
    }
};

export default CartComboServiceReducer;
